export const faq = [
  {
    question: 'Was macht eine Close CRM Agentur?',
    answer:
      'Eine Close CRM Agentur richtet Close (Close.com) für dein Vertriebsteam ein: Pipelines, Lead-Status, Custom Fields, Automatisierungen, Integrationen zu Kalender, Zoom, Formularen und Werbeanzeigen sowie Dashboards für Vertriebs- und Marketing-KPIs. Eine gute Agentur analysiert zuerst deinen Vertriebsprozess und betreut das System danach proaktiv weiter.',
  },
  {
    question: 'Woran erkenne ich die beste Close CRM Agentur für mein Unternehmen?',
    answer:
      'Prüfe sechs Punkte: Gehören dir alle Automatisierungen? Hat die Agentur mindestens 100 Close-Projekte umgesetzt? Wer ist dein Ansprechpartner und ist der Founder noch involviert? Wie schnell werden Probleme gelöst? Sind Dashboards und Setup individuell anpassbar? Und entwickelt die Agentur dein System proaktiv weiter?',
  },
  {
    question: 'Was kostet es, Close CRM von einer Agentur einrichten zu lassen?',
    answer:
      'Das hängt von Produkten, Zielgruppen, Vertriebsprozess und gewünschten Automatisierungen ab. Viele Unternehmen, die zu uns wechseln, haben bei anderen Agenturen bereits 10.000 bis 20.000 € für Setup und Betreuung bezahlt. Entscheidend ist nicht der günstigste Preis, sondern ein System, das langfristig skaliert und dir gehört. Im kostenlosen Erstgespräch bekommst du eine ehrliche Einschätzung.',
  },
  {
    question: 'Wie lange dauert eine Close CRM Implementierung?',
    answer:
      'Seriöse Implementierungen starten mit Kickoff-Call, Analyse und einem Report mit konkreten Vorschlägen. Die Dauer richtet sich danach, wie individuell dein Prozess ist. Vorsicht bei Angeboten wie „in zwei Tagen fertig“ – das ist fast immer eine Copy-Paste-Vorlage.',
  },
  {
    question: 'Kann ich meine Close CRM Agentur wechseln?',
    answer:
      'Ja. Rund die Hälfte unserer Anfragen kommt von Teams, die Close bereits nutzen und mit ihrer bisherigen Agentur unzufrieden sind. Wichtig ist, dass du Owner deiner Automatisierungen bist – sonst fallen sie beim Wechsel weg. Wir analysieren dein bestehendes System und übernehmen es strukturiert.',
  },
  {
    question: 'Wem gehören die Automatisierungen in meinem Close CRM?',
    answer:
      'Sie sollten immer dir gehören. Lass dir schriftlich bestätigen, dass alle Automatisierungen auf Servern und Accounts laufen, deren Owner du bist, und die Agentur nur Admin-Rechte hat. Bei CRM Kraft ist das Standard.',
  },
  {
    question: 'Reichen die Standard-Reports von Close aus?',
    answer:
      'Für viele Teams nicht. Close ist ein starkes Vertriebs-CRM, aber kein perfektes Reporting-Tool. Um Deals bis zur Marketingquelle und Anzeige zurückzuverfolgen und individuelle Vertriebs-KPIs auszuwerten, braucht es spezialisierte Dashboards. Bei uns kümmern sich zwei Spezialisten ausschließlich darum.',
  },
  {
    question: 'Wie erreiche ich euren Support?',
    answer:
      'Über eine eigene Gruppe in Slack, WhatsApp oder Telegram – für Teamleitung und Vertriebler. Wir sind Montag bis Sonntag von 9 bis 21 Uhr erreichbar und lösen Probleme direkt, statt sie in ein Ticketsystem zu buchen.',
  },
]
